import { forwardRef } from "react";

/**
 * ColorPanel - color or highlight picker panel
 */
export const ColorPanel = forwardRef(
  ({ colors, pos, onColorSelect, activeColor }, ref) => {
    if (!pos) return null;

    return (
      <div
        ref={ref}
        className="rte-color-panel"
        style={{ top: pos.top, left: pos.left }}
      >
        {colors.map((color) => (
          <button
            key={color}
            type="button"
            className={`rte-color-swatch${activeColor === color ? " active" : ""}`}
            style={{ background: color }}
            title={color}
            onMouseDown={(e) => {
              e.preventDefault();
              onColorSelect(color);
            }}
          />
        ))}
        <button
          type="button"
          className="rte-color-swatch rte-color-unset"
          title="Remove color"
          onMouseDown={(e) => {
            e.preventDefault();
            onColorSelect(null);
          }}
        >
          <span className="material-icons" style={{ fontSize: 14 }}>
            format_color_reset
          </span>
        </button>
      </div>
    );
  },
);

ColorPanel.displayName = "ColorPanel";
